// Google SecOps (Chronicle UDM) datasource mappings.
// Uses events field to carry the UDM metadata.event_type value(s) for each category.
// Single event: emitter produces metadata.event_type = "EVENT_TYPE"
// Multiple events: emitter produces (metadata.event_type = "E1" or\n  metadata.event_type = "E2")
// Joined with joinWithAnd since the renderer has no finalize() hook.
import type { DatasourceMap } from '../datasource.types'

export const googleSecOpsMap: DatasourceMap = {
  'Google SecOps': {
    any: {
      process_creation: { events: ['PROCESS_LAUNCH'] },
      file_event: { events: ['FILE_CREATION', 'FILE_MODIFICATION'] },
      network_connection: { events: ['NETWORK_CONNECTION'], unsupportedFields: ['domain', 'url'] },
      registry_event: { events: ['REGISTRY_CREATION', 'REGISTRY_MODIFICATION'] },
      dns: { events: ['NETWORK_DNS'] },
      image_load: { events: ['PROCESS_MODULE_LOAD'] },
      pipe_created: { unsupportedFields: ['process_path','process_name','pipe_name'] }, // Not supported so dropping the field that it requires
      //authentication_events: { events: ['USER_LOGIN', 'USER_LOGOUT'] },
      //system: { events: ['SERVICE_CREATION'] },
      //security: { events: ['SCHEDULED_TASK_CREATION'] },
      //Rdp_event: { events: ['USER_LOGIN'] },
    },
  },
}
